// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"ff41a498","581":"c1502d4e","829":"011823be","913":"5f5fe264"}[chunkId] + ".chunk.js";
};